import type { AddLibraryItemRequest, LibraryItem, ListLibraryResponse } from '@kreart/shared';
import { api } from '@/lib/api';

export const libraryApi = {
  list: () => api.get<ListLibraryResponse>('/library'),
  add: (body: AddLibraryItemRequest) => api.post<LibraryItem>('/library', body),
  remove: (catalogItemId: string) => api.delete<void>(`/library/${catalogItemId}`),
};
